import { useRef, useState } from 'react';
import useDraggable from '../../core/hooks/useDraggable';
import { ReturnTypeofSheetSectionsSelector } from '../selectors/sheetUiSelector';
import { UseSheetTheme } from './useSheetTheme';
import { GridEntity, SelectedLineType } from '../types';
import { IPosition2d } from '../../core/types/ui/position';
import { Size } from '../../core/types/ui/size';
import { UseGridOperations } from './useGridOperations';
import { SheetDefaults } from '../constants/sheetDefaults';
import { SheetCommandType } from '../types/commands/sheetCommands/sheetCommands';
import { useAppDispatch } from '../../core/hooks/storeHooks';
import { handleSheetOperations } from '../redux/sagas/root/rootActions';

export interface UseGridResizerProps
  extends ReturnTypeofSheetSectionsSelector,
    Pick<UseSheetTheme, 'stroke' | 'isRtl' | 'selectionBorder'>,
    IPosition2d,
    Size {
  sheetId: string;
  gridWidth: number;
}

export type OnResizerMouseDown = (
  e: React.MouseEvent,
  minPos: number,
  maxPos: number,
  linePos: number,
  index: number,
  lineType: SelectedLineType
) => void;

const getDefaultState = () => ({
  selectedLine: 'none',
  linePos: -1,
});
const getDefaultLineRef = () => ({
  selectedLine: 'none',
  minPos: 0,
  maxPos: 0,
  selectedIndex: -1,
});
export default ({ isRtl, zoom, ...props }: UseGridResizerProps) => {
  const dispatch = useAppDispatch();
  const [state, setState] = useState(getDefaultState());
  const selectedLineRef = useRef(getDefaultLineRef());

  const lineSize = zoom * SheetDefaults.resizerLineSize;

  // const rowResizerMax = props.y + props.height - lineSize;

  const onLineDrag = (
    x: number,
    y: number,
    e: MouseEvent,
    dragEnd?: boolean
  ) => {
    // Min and max position are relative position therefore we do not set them to 0
    // min pos can be 20 30 52 any number etc

    let pos = state.linePos;
    const selectedLine = selectedLineRef.current.selectedLine;
    const minPos = selectedLineRef.current.minPos;
    const maxPos = selectedLineRef.current.maxPos;

    if (selectedLineRef.current.selectedLine === GridEntity.Column) {
      const min = isRtl ? maxPos : minPos;
      const max = isRtl ? minPos : maxPos;
      pos = Math.min(Math.max(x, min), max);
    } else if (selectedLineRef.current.selectedLine === GridEntity.Row) {
      pos = Math.min(Math.max(y, minPos), maxPos);
    }

    setState((val) => ({
      ...val,
      linePos: pos,
    }));

    if (dragEnd) {
      // selectedLineRef.current.selectedLine ===

      const entityType =
        selectedLineRef.current.selectedLine === GridEntity.Column
          ? GridEntity.Column
          : GridEntity.Row;
      const index = selectedLineRef.current.selectedIndex;
      const size = getSize(selectedLine, minPos, pos, zoom);
      setState(getDefaultState());
      selectedLineRef.current = getDefaultLineRef();

      console.log('size-', size, '-', index);

      dispatch(
        handleSheetOperations({
          type: SheetCommandType.ResizeGrid,
          entity: entityType,
          positionIndex: index,
          size,
          sheetId: props.sheetId,
        })
      );
      // props.performGridOperation(entityType, {
      //   op: SheetCommandType.ResizeGrid,
      //   positionIndex: index,
      //   size,
      // });
    }
  };

  const { onMouseDown } = useDraggable({
    x: 0,
    y: 0,
    onDrag: onLineDrag,
  });

  const onResizerMouseDown = (
    e: React.MouseEvent,
    minPos: number,
    maxPos: number,
    linePos: number,
    index: number,
    lineType: SelectedLineType
  ) => {
    console.log('lineType', lineType);
    selectedLineRef.current = {
      selectedLine: lineType,
      minPos,
      maxPos,
      selectedIndex: index,
    };
    setState({
      selectedLine: lineType,
      linePos,
    });

    onMouseDown(e, linePos, linePos);
  };

  const getSize = (
    lineType: string,
    minPos: number,
    linePos: number,
    zoom: number
  ) => {
    if (lineType === GridEntity.Column) {
      return Math.abs(linePos - minPos) / zoom;
    } else if (lineType === GridEntity.Row) {
      return (linePos - minPos) / zoom;
    }
    return 0;
  };

  return {
    ...state,
    lineSize,
    onResizerMouseDown,
  };
};
